import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { GuestVerify } from "@/features/guest-booking/guest-verify";
import { PortalPage } from "@/features/portal/components/portal-chrome";
import { m } from "@/paraglide/messages.js";

/**
 * Where the link in a guest booking email lands. Public, because the person tapping it has no
 * account - that is the point of booking this way.
 */
export const Route = createFileRoute("/(public)/booking/verify/")({
  staticData: { sitemap: false },
  component: RouteComponent,
  loader: () => ({ crumb: m.guest_verify_crumb() }),
  validateSearch: z.object({ token: z.string().optional() }),
});

function RouteComponent() {
  const { token } = Route.useSearch();
  return (
    <PortalPage>
      <div className="mx-auto mt-10 max-w-[760px] px-5">
        <GuestVerify token={token} />
      </div>
    </PortalPage>
  );
}
